module.exports = __webpack_public_path__ + "static/Osiris-Ibague-73ff4e887668360bd006852b44edf664.png";